import { ProductFilter, Size } from '@trwl/backend.api';

/**
 * Преобразует фильтр в query string (без page).
 * @param filter
 * @returns строка query-параметров (без ведущего ?)
 */
export function serializeFilterToQuery(
  filter: Partial<Omit<ProductFilter, 'page'>>,
): string {
  const params = new URLSearchParams();

  if (filter.size !== undefined) params.set('size', String(filter.size));
  if (filter.keyword) params.set('keyword', filter.keyword);
  if (filter.sortField) params.set('sortField', filter.sortField);
  if (filter.sortOrder) params.set('sortOrder', filter.sortOrder);

  (
    [
      ['productIds', filter.productIds],
      ['brandIds', filter.brandIds],
      ['seriesIds', filter.seriesIds],
      ['fitIds', filter.fitIds],
      ['categoryIds', filter.categoryIds],
      ['sizeIds', filter.sizeIds],
    ] as const
  ).forEach(([key, arr]) => {
    if (arr && arr.length) {
      arr.forEach((v) => params.append(key, String(v)));
    }
  });

  if (typeof filter.stock === 'boolean')
    params.set('stock', String(filter.stock));

  if (filter.color) params.set('color', filter.color);

  if (filter.seasons && filter.seasons.length) {
    filter.seasons.forEach((season) => params.append('seasons', season));
  }

  if (filter.minPrice !== undefined)
    params.set('minPrice', String(filter.minPrice));
  if (filter.maxPrice !== undefined)
    params.set('maxPrice', String(filter.maxPrice));

  if (filter.sizes && filter.sizes.length) {
    filter.sizes.forEach((size) => {
      if (size.sizeType && size.sizeValue) {
        params.append('sizes', `${size.sizeType}:${size.sizeValue}`);
      }
    });
  }

  return encodeURIComponent(params.toString());
}

/**
 * Сериализует отдельное поле фильтра в query string.
 * @param key Ключ поля фильтра
 * @param filter Значение фильтра
 * @returns строка query-параметра (без ведущего ?)
 */
export function serializeFilterFieldToQuery<
  K extends keyof Omit<ProductFilter, 'page'>,
>(key: K, filter: Omit<ProductFilter, 'page'>): string {
  const value = filter[key];
  if (key === 'sizes') {
    return (value as Size[])
      .map((size) => `${size.sizeType}_${size.sizeValue}`)
      .join(',');
  }
  if (Array.isArray(value)) {
    return value.join(',');
  }
  if (value) return String(value);
  return '';
}
